import React from 'react'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, withStyles } from '@material-ui/core'
import { Releve } from '../account_model'
import { FormattedMessage, IntlShape, useIntl } from 'react-intl'
import StatusOP from './StatusOp'
import PdfIcon from './PdfIcon'
import classNames from 'classnames'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../../../../styles'

const useStyle = makeStyles((theme) => ({
	...styles(theme),
	textTable: {
		color: theme.palette.blue['50']
	},
	statusContainer: {
		display: 'flex',
		justifyContent: 'center',
		textAlign: 'center'
	}
}))

interface AcceptingProps {
	releves: Array<Releve>,
	setOpenPayment: (amount: number, facture: string, piece_numero: string) => void,
	paymentDisabled: boolean
}

type TableOpProps = AcceptingProps

const StyledTableCell = withStyles((theme) => ({
		root: {
			padding: '3% 0px'
		},
		body: {
			borderBottom: 'none',
			borderTop: `1px solid ${theme.palette.blue['10']}`
		}
	}
))(TableCell)

const TableOp: React.FC<TableOpProps> = (
	{
		releves,
		setOpenPayment,
		paymentDisabled
	}
) => {
	const classes = useStyle()
	const intl: IntlShape = useIntl()

	const column1: string = intl.formatMessage({ id: 'contracts.account.deadline', defaultMessage: 'Echéance', description: 'Table Deadline column text' })
	const column2: string = intl.formatMessage({ id: 'contracts.account.operation', defaultMessage: 'Libellé opération', description: 'Table Operation column text' })
	const column3: string = intl.formatMessage({ id: 'contracts.account.amount', defaultMessage: 'Montant', description: 'Table Amount column text' })
	const column4: string = intl.formatMessage({ id: 'contracts.account.status', defaultMessage: 'Statut', description: 'Table Status column text' })

	const columnName = classNames(
		classes.text2,
		classes.medium,
		classes.textTable
	)

	const labelOperation = classNames(
		classes.colorBlue,
		classes.semiBold,
		classes.text8
	)

	return (
		<TableContainer>
			<Table>
				<TableHead>
					<TableRow>
						<StyledTableCell className={columnName}>{column1}</StyledTableCell>
						<StyledTableCell className={columnName}>{column2}</StyledTableCell>
						<StyledTableCell className={columnName} align="center">{column3}</StyledTableCell>
						<StyledTableCell className={columnName} align="center">{column4}</StyledTableCell>
						<StyledTableCell />
					</TableRow>
				</TableHead>
				<TableBody>
					{releves.map((statement: Releve, key) => (
						<TableRow key={key}>
							<StyledTableCell className={columnName}>
								{statement.date_exigible?.toLocaleDateString()}
							</StyledTableCell>
							<StyledTableCell className={labelOperation}>
								{statement.operation_type}
							</StyledTableCell>
							<StyledTableCell align="center" className={labelOperation}>
								{
									statement.operation_mtcredit ?
										`+ ${Number(statement.operation_mtcredit).toLocaleString()}`
										:
										`- ${Number(statement.operation_mtdebit).toLocaleString()}`
								}
								<FormattedMessage
									id="contracts.account.euro"
									defaultMessage=" €"
									description="Account euro"
								/>
							</StyledTableCell>
							<StyledTableCell align="center">
								<div className={classes.statusContainer}>
									<StatusOP
										paymentDisabled={paymentDisabled}
										mttcRestant={statement.facture_mttcrestant}
										isPartial={statement.facture_mttcrestant !== statement.operation_mtdebit}
										isCredit={!!statement.operation_mtcredit}
										setOpenPayment={setOpenPayment}
										factureLabel={statement.operation_type}
										pieceNumero={statement.piece_numero}
										numBail={statement.bail_ref}
									/>
								</div>
							</StyledTableCell>
							<StyledTableCell>
								<PdfIcon operation={statement} />
							</StyledTableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	)
}

export default TableOp
